<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form
        ref="form"
        :model="queryForm.params"
        label-position="top"
        label-width="auto"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <!--客户名称-->
            <el-form-item :label="$t('basicData.CustomerName')" prop="customerId">
              <!--              <el-input-->
              <!--                v-model="queryForm.params.customerId"-->
              <!--                :placeholder="$t('GlobalSetObj.pleaseInput')"-->
              <!--                clearable-->
              <!--              />-->
              <QueryCustomerCmp
                :val="queryForm.params.customerId"
                @change="(val) => (queryForm.params.customerId = val)"
              />
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item class="btn-label">
              <el-button
                v-permit:remove="'btn:finance:fundManagement:fundLedger:page'"
                icon="el-icon-search"
                size="small"
                type="primary"
                @click="searchResources"
              >
                {{ $t('operationCenter.Procurar') }}
              </el-button>
              <!--重 置-->
              <el-button icon="el-icon-refresh" size="small" @click="onReset">{{ $t('basicData.reset') }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div class="feet-s mb10">
        <div class="feet-r">
          <!-- 导出 -->
          <el-button
            v-permit:remove="'btn:finance:fundManagement:fundLedger:export'"
            class="feet-btn"
            size="small"
            @click="onExport"
          >{{ $t('receivablePayable.Export') }}
          </el-button>

          <!--自定义栏目-->
          <CustomStatusBar
            :columns-data="columns"
            :params="searchParams"
            :save-params="customParams"
            class="feet-btn"
            @updateColumns="updateColumns"
          />

          <!--          消息配置-->
          <el-button
            v-permit:remove="'btn:finance:fundManagement:fundLedger:export'"
            class="feet-btn"
            size="small"
            type="primary"
            @click="openNotificationStrategyConfig"
          >{{ $t('basicData.NotificationStrategyConfiguration') }}
          </el-button>

          <div class="label">
            {{ $t('basicData.TotalRechargeAmount') }}：{{
              formatConversion(statistics.totalAmount)
            }}
          </div>
          <div class="label">
            {{ $t('basicData.PreOccupiedSum') }}：{{ formatConversion(statistics.occupiedAmount) }}
          </div>
          <div class="label">
            {{ $t('basicData.AmountDeductedSum') }}：{{
              formatConversion(statistics.deductedAmount)
            }}
          </div>
          <div class="label">
            {{ $t('basicData.RemainingAvailableSum') }}：{{
              formatConversion(statistics.availableAmount)
            }}
          </div>
        </div>
      </div>

      <el-table
        :key="tableKey"
        ref="table"
        :data="tableData"
        :height="tableHeightRow.height"
        border
        class="table-height"
        @selection-change="handleSelectionChange"
      >
        <!--        <el-table-column type="selection" width="55" align="center" />-->
        <!--序号-->
        <el-table-column :label="$t('basicData.serialNumber')" align="center" width="60px">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in currentColumns"
          :key="ind"
          :align="item.align"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!--            累计总金额 -->
            <span v-if="item.prop === 'serialNo'" class="serialNo">
              <span
                v-if="scope.row.isParent === true"
                class="batchNumber"
                @click="view(2, scope.row)"
              >{{ scope.row.serialNo }}</span>
            </span>

            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100, 500]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getCurrentPage"
          @size-change="getSizePage"
        />
      </div>
    </el-card>

    <!--    配置弹窗-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
      @close="closeDialog"
    >
      <template slot="title">
        <div class="dialog-title">
          <span>{{ $t('basicData.NotificationStrategyConfiguration') }}</span>
          <span class="tips">
            <i class="el-icon-info" />
            {{ $t('basicData.NotificationBasedOnCustomerDimension') }}</span>
        </div>
      </template>
      <NotificationStrategyConfig :visible="dialogVisible" @close="closeDialog" />
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { goFinanceExportPage } from '@/utils/goExportList.js';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { columns } from './utils';
import {
  apiOfferPriceExport,
  apiOfferPricePage,
  apiOfferPriceStatistics
} from '@/api/finance/fundManagement';
import NotificationStrategyConfig from './NotificationStrategyConfig.vue';

export default {
  name: 'FundLedger',

  components: {
    NotificationStrategyConfig,
    QueryCustomerCmp: () => import('@/views/finance/cmp/Query/QueryCustomerCmp.vue'),
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue')
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      dialogVisible: false,
      columns, // 表头
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          customerId: '' // 客户名称
        }
      },
      selectData: [], // 勾选
      tableData: [], // 表格数据
      total: 0,
      tableKey: new Date().getTime(),

      // 统计
      statistics: {
        totalAmount: 0, // 累计总金额
        occupiedAmount: 0, // 预占用金额
        deductedAmount: 0, // 已扣款金额
        availableAmount: 0 // 剩余可用金额
      },

      currentColumns: [], // 自定义列
      searchParams: {
        type: 0,
        menuEnum: 'fundLedger'
      },
      customParams: {
        templateField: '',
        templateName: '资金台账',
        userId: '',
        type: 0,
        menuEnum: 'fundLedger'
      }
    };
  },

  created() {
    // 获取列表
    this.getContractPage();
    this.getStatistics();
  },
  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
        this.tableKey = new Date().getTime();
      });
    },

    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },

    searchResources() {
      this.queryForm.pageNumber = 1;
      this.getContractPage();
      this.getStatistics();
    },

    // 重置
    onReset() {
      this.$refs.form.resetFields();
      this.getContractPage();
      this.getStatistics();
    },

    // 翻页
    getCurrentPage(val) {
      this.queryForm.pageNumber = val;
      this.getContractPage();
    },

    // 每页显示数量变化
    getSizePage(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getContractPage();
    },

    // 获取列表数据
    getContractPage() {
      apiOfferPricePage(this.queryForm)
        .then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.tableData = data.records || [];
            this.total = res.data.total;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 千分位转换
    formatConversion(val) {
      if (val === null || val === undefined || val === '') return '0';
      return Number(val).toLocaleString('en-US');
    },

    // 统计
    getStatistics() {
      const { params } = this.queryForm;
      apiOfferPriceStatistics(params).then((res) => {
        if (res.code === 200) {
          this.statistics = res.data;
        }
      });
    },

    // 导出
    onExport() {
      const ids = this.selectData.map((item) => item.id);
      const { params } = this.queryForm;
      params.ids = ids;
      apiOfferPriceExport(params)
        .then((res) => {
          if (res.code === 200) {
            goFinanceExportPage();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 消息通知配置
    openNotificationStrategyConfig() {
      this.dialogTitle = this.$t('basicData.NotificationStrategyConfiguration');
      this.dialogVisible = true;
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }

  .btn-label {
    margin-top: 28px;
  }
}

.label {
  color: #fff;
  font-size: 14px;
  background-color: #da4d4d;
  padding: 8px 20px;
  border-radius: 15px;
}

.dialog-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;

  .tips {
    margin-left: 30px;
    font-size: 12px;
    color: #909399;
  }
}
</style>
